import React, { useEffect, useState } from 'react';
import { SvgProps, SvgXml } from 'react-native-svg';

export type UriProps = {
    uri?: string | null;
} & SvgProps;

export function SvgUri(props: UriProps) {
    const { uri, ...restProps } = props;
    const [xml, setXml] = useState<null | string>(null);

    useEffect(() => {
        const fetchController = new AbortController();

        if (uri) {
            fetch(uri, { signal: fetchController.signal })
                .then((response) => response.text())
                .then((response) => {
                    if (!fetchController.signal.aborted) {
                        setXml(response);
                    }
                })
                .catch((error) => {
                    if (error.name === 'AbortError') {
                        // Ignore abort errors,component unmounted
                    } else {
                        // Optionally handle error
                        console.error('Error fetching SVG:', error);
                    }
                });
        }

        return () => fetchController.abort();
    }, [uri]);
    return xml ? <SvgXml xml={xml} {...restProps} /> : null;
}
